var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "alert",
      class: `alert--${_vm.computedVariant}`,
      attrs: { role: "alert" },
    },
    [
      _c(
        "div",
        { staticClass: "alert__main" },
        [
          _c(
            "div",
            { staticClass: "alert__title" },
            [
              _c("jade-icon", {
                staticClass: "alert__icon",
                attrs: {
                  color: "on-color-high",
                  size: "medium",
                  use: _vm.icon,
                },
              }),
              _c("strong", [_vm._v(_vm._s(_vm.title))]),
            ],
            1
          ),
          _vm.message
            ? _c("div", { staticClass: "alert__content" }, [
                _c("p", [_vm._v(_vm._s(_vm.message))]),
              ])
            : _vm._e(),
          _vm.isTestAccount
            ? [
                _vm.helpLink
                  ? _c(
                      "a",
                      {
                        staticClass: "alert__help",
                        attrs: {
                          href: _vm.helpLink.href,
                          target: "_blank",
                          title: _vm.helpLink.text,
                        },
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.helpLink.text) + " "),
                        _c("jade-icon", {
                          attrs: {
                            color: "on-color-high",
                            size: "small",
                            use: "arrow-north-east",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.dismissible
            ? _c("jade-icon-button", {
                staticClass: "alert__close",
                attrs: {
                  size: "small",
                  icon: "close",
                  variant: "on-brand-ghost",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }